import React from 'react';
import { createSafeHTML } from '../utils/sanitize';

/**
 * Safe HTML component that sanitizes content before rendering
 * Use this instead of dangerouslySetInnerHTML
 */
const SafeHTML = ({ html, tag: Tag = 'div', className = '', ...props }) => {
  return (
    <Tag 
      className={className} 
      dangerouslySetInnerHTML={createSafeHTML(html)}
      {...props}
    />
  );
};

export default SafeHTML;
